import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Injectable({
    "providedIn": "root"
  })
  @Pipe({
    name: 'purchaseorderstatus',
    standalone: true
  })
export class PurchaseOrderStatusPipe implements PipeTransform {
    transform(value: number, isLotReport: boolean = false, statusDate: number = null, invoiceNumber: string = null): string {
        var _statusDate: string = "";
        var _invoiceNumber: string = "";
        var _lawsonDate: string = "";
        if (isLotReport) {
            _statusDate = statusDate == null ? "MM/DD/YYYY" : new Date(statusDate).toDateString();
            _invoiceNumber = invoiceNumber == null || invoiceNumber.length <= 0 ? "000000" : invoiceNumber;
        }

        switch (value) {
            case 1:
                return isLotReport ? "Submitted - Not Approved" : "Submitted";
            case 2:
                return "Approved";
            case 3:
                return isLotReport ? "Approved, Vendor Invoiced (" + _invoiceNumber + "), Sent to Lawson on " + _statusDate : "Extracted For Payment";
            case 4:
                return isLotReport ? "Void" : "Voided";
            case 5:
                return isLotReport ? "Approved, Vendor Invoiced on " + _statusDate + " (" + _invoiceNumber + ")" : "Invoiced";
            case 6:
                return "Requested";
            case 7:
                return "Denied";
            case 8:
                return "Returned";
            default:
                return "";
        }
    }
}
